<template>
  <div
      class="concert-wrapper"
  >
    <div class="concert">
      <div class="labels">
        <p class="label tip" v-if="concert.humo_recommends">Humo tip</p>
        <p class="label genre" v-if="concert.genre && !concert.is_multiple">
          {{ concert.genre }}
        </p>
      </div>
      <div class="concert-image">
        <img v-if="concert.image.length > 0" :src="concert.image" alt="" class="image" loading="lazy" :alt="concert.title">
        <img v-else-if="concert.image.length === 0" src="/images/placeholder.jpg" alt="" class="image" loading="lazy" :alt="concert.title">
      </div>
      <div class="title-box">
        <p class="date mb-0">{{ parsedDates(concert.dates) }}</p>
        <h2 class="concert-title mb-0" v-html="concert.name"></h2>
        <p class="concert-subtitle mb-0">
          <span>{{ concert.city }} </span>
          <svg class="icon-dots" fill="#000000" height="800px" width="800px" id="Layer_1" data-name="Layer 1"
               xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
            <path class="cls-1" d="M6.5,11A1.5,1.5,0,1,1,5,9.5,1.5,1.5,0,0,1,6.5,11ZM5,3.5A1.5,1.5,0,1,0,6.5,5,1.5,1.5,0,0,0,5,3.5ZM12.5,11A1.5,1.5,0,1,1,11,9.5,1.5,1.5,0,0,1,12.5,11ZM11,3.5A1.5,1.5,0,1,0,12.5,5,1.5,1.5,0,0,0,11,3.5Z"/>
          </svg>
          {{ concert.venue }}
        </p>
      </div>
      <div class="info"
      >
        <div class="info-badges">
          <div class="badge badge-free" v-if="concert.is_free">
            <span>gratis</span>
          </div>
          <div class="badge badge-sold-out" v-if="concert.sold_out">
            <span>sold<br>out</span>
          </div>
          <a :href="concert.ticket_link" target="_blank" class="badge badge-tickets" v-if="concert.ticket_link && !concert.sold_out">
            <span>tickets</span>
          </a>
          <a :href="concert.ticketswap_link" target="_blank" class="badge badge-tickets" v-if="concert.ticketswap_link && concert.sold_out">
            <span>ticket<br>swap</span>
          </a>
        </div>
        <div class="info-content">
          <p class="description" v-html="concert.description"></p>
          <div
              class="links"
              v-if="concert.info.cta_text && concert.info.link"
          >
            <a
                class="link"
                target="_blank"
                :href="concert.info.link"
            >
              <p class="link-text">{{ concert.info.cta_text }}</p>
            </a>
          </div>
          <div
              class="links"
              v-if="concert.link.text && concert.link.link"
          >
            <a
                class="link"
                target="_blank"
                :href="concert.link.link"
            >
              <p class="link-text" v-html="concert.link.text"></p>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import dayjs from 'dayjs'
import { nl } from 'dayjs/locale/nl'

dayjs.locale('nl')

const props = defineProps({ concert: Object })

function parsedDates(dates) {
  if (dates.length === 1) return dayjs(dates[0]).format('dddd D MMMM')
  else {
    let datesPerMonth = {}
    let parsedString = ''

    dates.forEach(date => {
      datesPerMonth.hasOwnProperty(dayjs(date).format('MMMM')) ? datesPerMonth[dayjs(date).format('MMMM')].push(date) : datesPerMonth[dayjs(date).format('MMMM')] = [date]
    })

    Object.values(datesPerMonth).forEach(month => {
      if (parsedString.length > 0) parsedString = parsedString + ', '

      month.forEach((date, index) => {
        if (index === month.length - 1) {
          parsedString = parsedString + dayjs(date).format('dddd D')
        } else if (index === month.length - 2) {
          parsedString = parsedString + dayjs(date).format('dddd D') + ' en '
        } else {
          parsedString = parsedString + dayjs(date).format('dddd D') + ', '
        }
      })
      parsedString = parsedString + ` ${dayjs(month[0]).format('MMMM')}`
    })

    return parsedString
  }
}
</script>
